import { ConvexBetterAuthProvider } from "@convex-dev/better-auth/react"
import type { ConvexReactClient } from "convex/react"
import type { ComponentProps, ReactNode } from "react"

import { ErrorBoundary } from "../error/error-boundary"

type AuthClient = ComponentProps<typeof ConvexBetterAuthProvider>["authClient"]

export function ConvexProvider({
  client,
  authClient,
  children,
}: {
  client: ConvexReactClient
  authClient: AuthClient
  children: ReactNode
}) {
  return (
    <ErrorBoundary>
      <ConvexBetterAuthProvider client={client} authClient={authClient}>
        {children}
      </ConvexBetterAuthProvider>
    </ErrorBoundary>
  )
}
